import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faDownload,
  faCircle,
  faTimes,
  faEdit,
  faEnvelope,
  faPhone,
  faPlus,
  faArrowLeft,
  faLocationArrow,
  faSchool,
  faSort,
  faSortDown,
  faSortUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faExclamationCircle,
  faCheckCircle,
  faMap,
  faBars,
  faGraduationCap,
  faUsers,
  faUser,
  faUserCog,
  faQuestionCircle,
  faComments,
  faSignOutAlt,
  faCog,
  faCalendarAlt as fasCalendarAlt,
  faUserClock,
  faTrash,
  faCheck,
  faTimesCircle,
  faCheckSquare,
  faCalendar,
  faMapPin,
  faChevronLeft,
  faChevronRight,
  faInfoCircle,
  faCopy,
  faExclamationTriangle,
  faSearchMinus,
  faSearch,
  faBell,
  faUniversity,
  faUserGraduate,
  faArrowRight,
  faVideo,
  faClock,
  faLock,
  faUnlock,
  faFileInvoice,
  faFileAlt,
  faFile,
  faCalendarCheck,
  faCertificate,
  faUserCheck,
  faHistory,
  faFilePdf,
  faUpload,
  faChevronDown,
  faChevronUp,
  faSave,
  faThumbsUp,
  faImages,
  faHourglassEnd,
  faCalendarWeek,
  faDollarSign,
  faCoins,
  faPenAlt,
  faLanguage,
  faPassport,
  faGripHorizontal,
  faTrashAlt,
  faCalendarMinus,
  faClipboardCheck,
  faClipboardList,
  faShareAlt,
  faLink,
  faChartLine,
  faSeedling,
  faFileImport,
  faGlobeAmericas,
  faChartPie,
  faBookmark,
  faGlobe,
  faArrowsAlt,
  faHandsHelping,
  faUserFriends,
  faCommentDots,
  faBullhorn,
  faStar,
  faColumns,
  faGem,
  faUnlink,
  faFire,
  faPaperPlane,
  faCodeBranch,
  faGripVertical,
  faAlignLeft,
  faMinus,
  faGripLines,
  faCommentAlt,
  faMountain,
  faLongArrowAltRight,
  faTrashCan,
  faLayerGroup,
  faShare,
  faShareFromSquare,
  faBook,
  faSpinner,
  faFilter,
  faUsersViewfinder,
  faRocket,
  faGears,
  faCaretDown,
  faEye,
  faEyeSlash,
  faPlane,
  faBuilding,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCircle as farCircle,
  faSquare,
  faCalendarAlt,
  faCopy as farCopy,
  faFileImage as farFileImage,
  faCircleQuestion,
  faCircleCheck as farCircleCheck,
} from "@fortawesome/free-regular-svg-icons";
import {
  faFacebookSquare,
  faTwitterSquare,
  faChrome,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import {
  faSparkles,
  faFileChartPie,
  faCommentLines,
  faPoll,
  faLightbulbOn,
  faLightbulb,
  faHandsHoldingDollar,
  faSensorTriangleExclamation,
  faPartyHorn,
  faCrosshairsSimple,
  faBullseyeArrow,
  // faShieldCheck,
  faPenLine,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faExclamationTriangle as farExclamationTriangle,
  faFilter as faFilterReg,
  faShieldCheck,
  faArrowUpFromBracket,
  faSearch as farSearch,
  faStar as farStar,
  faLink as farLink,
  faUserGroup as farUserGroup,
  faChartPie as farChartPie,
  faChartUser as farChartUser,
  faListTree as farListTree,
  faArrowsTurnToDots as farArrowsTurnToDots,
  faEarthAmericas as farEarthAmericas,
  faFileSpreadsheet as farFileSpreadsheet,
  faCircleXmark as farCircleXmark,
  faListRadio as farListRadio,
  faCircleInfo as farCircleInfo,
  faListTimeline as farListTimeline,
  faTimer as farTimer,
  faFire as farFire,
  faTemperatureHigh as farTemperatureHigh,
  faIgloo as farIgloo,
  faScreenUsers as farScreenUsers,
  faHeadset as farHeadset,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faArrowLeftToLine as farArrowLeftToLine,
  faArrowRightToLine as farArrowRightToLine,
  faEnvelope as farEnvelope,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faInfoCircle as falInfoCircle,
  faStar as falStar,
  faPencil as falPencil,
} from "@fortawesome/pro-light-svg-icons";

library.add(
  faEye,
  faEyeSlash,
  faPlane,
  faWhatsapp,
  faBuilding,
  faMobileAlt,
  faCheckSquare,
  faSquare,
  faCircle,
  faTimes,
  faEdit,
  faEnvelope,
  faPhone,
  faDownload,
  faPlus,
  faArrowLeft,
  faLocationArrow,
  faSchool,
  faSort,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faExclamationCircle,
  faCheckCircle,
  faMap,
  faSortDown,
  faBars,
  faGraduationCap,
  faCalendarAlt,
  faUsers,
  faUser,
  faUserCog,
  faQuestionCircle,
  faComments,
  faFacebookSquare,
  faTwitterSquare,
  faChrome,
  faSignOutAlt,
  faCog,
  fasCalendarAlt,
  faUserClock,
  faTrash,
  faCheck,
  faTimesCircle,
  faSortUp,
  faCalendar,
  faMapPin,
  faChevronLeft,
  faChevronRight,
  farCircle,
  faInfoCircle,
  falInfoCircle,
  faExclamationTriangle,
  faSearchMinus,
  faSearch,
  faCopy,
  faBell,
  faUniversity,
  faUserGraduate,
  faArrowRight,
  faVideo,
  faClock,
  faLock,
  faUnlock,
  faFileInvoice,
  faFileAlt,
  faFile,
  faCalendarCheck,
  faCertificate,
  faUserCheck,
  faHistory,
  farCopy,
  faFilePdf,
  faUpload,
  faChevronDown,
  faChevronUp,
  faSave,
  faThumbsUp,
  faImages,
  faHourglassEnd,
  faCalendarWeek,
  faDollarSign,
  faCoins,
  faPenAlt,
  faLanguage,
  faPassport,
  faGripHorizontal,
  faTrashAlt,
  faCalendarMinus,
  faClipboardCheck,
  faClipboardList,
  faShareAlt,
  faLink,
  faChartLine,
  faSeedling,
  faFileImport,
  faGlobeAmericas,
  faChartPie,
  faBookmark,
  faGlobe,
  faArrowsAlt,
  faHandsHelping,
  faUserFriends,
  faCommentDots,
  faBullhorn,
  faStar,
  faColumns,
  faGem,
  faSparkles,
  faCommentLines,
  faUnlink,
  faFire,
  faPaperPlane,
  faCodeBranch,
  faGripVertical,
  faAlignLeft,
  faMinus,
  faGripLines,
  faFileChartPie,
  faCommentAlt,
  faMountain,
  faPoll,
  faLongArrowAltRight,
  faTrashCan,
  faLayerGroup,
  faLightbulbOn,
  faLightbulb,
  faHandsHoldingDollar,
  faShare,
  faShareFromSquare,
  farExclamationTriangle,
  faBook,
  faSpinner,
  faFilter,
  faFilterReg,
  faSensorTriangleExclamation,
  farFileImage,
  faPartyHorn,
  faCircleQuestion,
  faShieldCheck,
  faArrowUpFromBracket,
  farSearch,
  falStar,
  faStar,
  farStar,
  farLink,
  faCrosshairsSimple,
  faBullseyeArrow,
  faUsersViewfinder,
  faLinkedin,
  farUserGroup,
  farChartPie,
  farChartUser,
  faRocket,
  farCircleCheck,
  faGears,
  farListTree,
  farArrowsTurnToDots,
  farEarthAmericas,
  farFileSpreadsheet,
  farCircleXmark,
  farListRadio,
  farCircleInfo,
  farListTimeline,
  farTimer,
  faCaretDown,
  farFire,
  farTemperatureHigh,
  farIgloo,
  farScreenUsers,
  faPenLine,
  farHeadset,
  farArrowUpRightFromSquare,
  farChevronLeft,
  farChevronRight,
  farArrowLeftToLine,
  farArrowRightToLine,
  farEnvelope,
  falPencil,
);
